export class SearchOperation
{
    static getTokens(search: string): string[]
    {
        return search.split(' ').filter(x => x.trim()).map(x => x.toLowerCase());
    }
    static match(value: string | null, search: string, tokens: string[] = []): boolean
    {
        if (search)
        {
            if (!value)
                return false;
            if (tokens.length == 0)
                tokens = search.split(' ').filter(x => x.trim()).map(x => x.toLowerCase());
            let name = value.toLowerCase();
            for (let i = 0; i < tokens.length; i++)
                if (!name.toLowerCase().includes(tokens[i]))
                    return false;
        }
        return true;
    }
    static filter<T>(array: T[], getValue: (item: T) => string, search: string): T[]
    {
        let ans = array;
        if (search)
        {
            let tokens = this.getTokens(search);
            ans = ans.filter((item) => SearchOperation.match(getValue(item), search, tokens));
        }
        return ans;
    }
}